/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';
import LoadingAnimation from '@g17eco/atoms/loading-animation';
import { QUESTION } from '@constants/terminology';

const LoadingBar = () => {
  return <div className='onboarding-form'>
    <aside className='title-container'>
      <div className='h1 mb-3'>Generating your sustainability {QUESTION.PLURAL}</div>
      <p>This will only take a few seconds</p>
    </aside>
    <section className='loadingBar-container'>
      <LoadingAnimation />
    </section>
  </div>
}

export default LoadingBar;
